// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"1beaef366772e2ade5be","263":"2593a4b763d3c23e6dae","791":"36952af81ece83d278c5"}[chunkId] + ".js";
};